const INSTALLMENT = {
  id: 'installment',
  label: 'list.installment',
  type: 'text'
}
const TOTAL_VALUE = {
  id: 'totalValue',
  label: 'list.totalValue',
  type: 'text'
}

const FIELDS = [INSTALLMENT, TOTAL_VALUE]

export { FIELDS }
